<main [@routeAnimations]="o.isActivated && o.activatedRoute.routeConfig.path" style="overflow: hidden;">
  <router-outlet #o="outlet"></router-outlet>
</main>